import React from 'react';
import {FormGroup, Button, ButtonGroup, Card, InputGroup, Intent} from '@blueprintjs/core';
import {Popover2} from '@blueprintjs/popover2';

import './NumberFormat.scss';

interface NumberFormatProps {
  isPercentage: boolean;
  value: string;
  onChange: (value: string, isPercentage: boolean) => void;
  disabled?: boolean;
}

interface NumberFormatMenuProps extends NumberFormatProps {
}

const NumberFormatMenu = ({
  isPercentage,
  value,
  onChange,
}: NumberFormatMenuProps) => {
  const onInputChange = (event: any) => {
    onChange(event.target.value, isPercentage);
  };

  const onIsPercentageChange = (_isPercentage: boolean) => {
    let _format = value || '';

    if (_isPercentage && !_format.endsWith('%')) {
      // append % to format
      onChange(`${_format}%`, _isPercentage);
    } else if (!_isPercentage && _format.endsWith('%')) {
      // remove % from format
      onChange(_format.substring(0, _format.length - 1), _isPercentage);
    } else {
      // no change in format (backwards compatibility)
      onChange(_format, _isPercentage);
    }
  }

  return (
    <Card className="number-format-popover">
      <ButtonGroup fill={true}>
        <Button
          text="Number"
          active={!isPercentage}
          intent={!isPercentage ? Intent.PRIMARY : undefined}
          onClick={() => onIsPercentageChange(false)}
        />
        <Button
          text="Percentage"
          active={isPercentage}
          intent={isPercentage ? Intent.PRIMARY : undefined}
          onClick={() => onIsPercentageChange(true)}
        />
      </ButtonGroup>
      <FormGroup>
        <InputGroup
            placeholder="#,##0.###"
            value={value}
            onChange={onInputChange}
        />
      </FormGroup>
    </Card>
  )
};

const NumberFormat = ({
  isPercentage,
  value,
  onChange,
  disabled,
}: NumberFormatProps) => {
  return (
    <FormGroup inline={true} label="Format">
      <Popover2
        content={
          <NumberFormatMenu
            isPercentage={isPercentage}
            value={value}
            onChange={onChange}
            disabled={disabled}
          />
        }
      >
        <Button
          text={value}
          minimal={true}
          outlined={true}
          small={true}
          disabled={disabled}
        />
      </Popover2>
    </FormGroup>
  )
};

export default NumberFormat;
